import pl from "@locales/sales_storefront/pl.json";
import en from "@locales/sales_storefront/en.json";

export default {
  pl: pl,
  en: en,
};
